import { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import '../App.css';
import '../Tabs.css';
import 'rsuite/DatePicker/styles/index.css';
import { handleErrors, request } from '../utils/ApiUtils';
import Table from './Table';
import { formatToBRL } from '../utils/MonetaryUtils';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ScheduleIcon from '@mui/icons-material/Schedule';

function BalancoFinanceiroDespesasTab(props) {
    const [dataArray, setDataArray] = useState([]);
    const [despesas, setDespesas] = useState([]);
    const [loading, setLoading] = useState({loading: false});
    const [fetchListError, setFetchListError] = useState();

    const carregarDados = async (page = 0) => {
        setLoading({loading: true});

        if (props.ano && props.mes)
            request(`balanco-financeiro/despesas/${props.mes}/${props.ano}`, {
                type: 'GET',
                callback: (data) => (
                    setDataArray(data.content),
                    setDespesas(data)
                ),
                finally: () => setLoading({loading: false}),
                callbackError: (responseData, message) => {
                    handleErrors(responseData, 'Falha ao consultar despesas, por favor, atualize a tela ou tente novamente.  \n' + message, {setFetchListError});
                }
            })
    };

    useEffect(() => {
        carregarDados();

    }, [props.refreshKey]);



    const footerTotals = () => (
        <div style={{ paddingTop: '20px' }}>
            <h4 style={{ color: 'green', paddingBottom: '5px' }}>{`Valor total pago: ${formatToBRL(despesas?.valorTotalPago)}`}</h4>
            <h4 style={{ color: 'orange' }}>{`Valor total a pagar: ${formatToBRL(despesas?.valorTotalAPagar)}`}</h4>
        </div>
    )

    const tableParams = {
        query: (page) => carregarDados(page),
        // hasFooter: true,
        columns: [
            {
                label: "Classificação",
                width: "25%",
                widthValue: '45%',
                disabled: true,
                type: "input",
                key: "categoria"
            },
            {
                label: "Valor",
                width: "40%",
                widthValue: '45%',
                disabled: true,
                type: "input-decimal",
                css: "decimal",
                key: "valor",
                // htmlFooter: () => footerTotals()
            }
        ]
    };

    return (
        <div className="form-container">

            <div id="notification-container" className='notification-container' style={{
                position: "fixed",
                display: "flex,",
                flexDirection: "column-reverse",
                justifyContent: "flex-end",
                flexWrap: "wrap-reverse",
                alignItems: "flex-end",
                bottom: "0,",
                right: "30px",
                maxHeight: "100vh"
            }}></div>

            <div className="receitas-summary" aria-label="Resumo das despesas">
                <section className="receitas-summary-card receitas-summary-card-received">
                    <span className="receitas-summary-label">Pago</span>
                    <strong>{formatToBRL(despesas?.valorTotalPago)}</strong>
                    <span className="receitas-summary-description">
                        <CheckCircleOutlineIcon aria-hidden="true" />
                        Valores já pagos
                    </span>
                </section>
                <section className="receitas-summary-card receitas-summary-card-pending">
                    <span className="receitas-summary-label">A pagar</span>
                    <strong>{formatToBRL(despesas?.valorTotalAPagar)}</strong>
                    <span className="receitas-summary-description">
                        <ScheduleIcon aria-hidden="true" />
                        Valores pendentes
                    </span>
                </section>
            </div>

            <Table params={tableParams} dataArray={despesas?.parcelas || []} loading={loading}  errorOccurred={fetchListError} />
        </div>
    );
}

export default BalancoFinanceiroDespesasTab;
